export interface ShowMoreProps {
  /** How many items are on screen. */
  shown: number;
  total: number;
  onMore: () => void;
  /** How many more a click reveals, at most. */
  step?: number;
  busy?: boolean;
}

/** Footer button for a list shown in pages. Renders nothing once everything is shown. */
export function ShowMore({ shown, total, onMore, step = 20, busy }: ShowMoreProps) {
  if (total <= shown) return null;
  const older = total - shown;
  return (
    <button
      type="button"
      className="nb-btn nb-btn-ghost"
      onClick={onMore}
      disabled={busy}
      style={{
        width: '100%',
        justifyContent: 'center',
        height: 32,
        fontSize: 12,
        marginTop: 6,
        borderStyle: 'dashed',
      }}
    >
      {busy ? 'Loading…' : `Show ${Math.min(step, older)} more`}
      {!busy && <span style={{ color: 'var(--nb-muted)', marginLeft: 4 }}>· {older} older</span>}
    </button>
  );
}
